import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Login.css";
import Header from "../Components/Header";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import axios from "../api/axios";

export default function Login() {
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const login_by = emailOrPhone.includes("@") ? "email" : "phone";

    axios.post("/auth/login", {
      email: emailOrPhone,
      password: password,
      login_by: login_by
    })
    .then((response) => {
      if (response.data.result) {
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        window.dispatchEvent(new Event("user-profile-updated"));

        axios.get("/wishlists", {
          headers: {
            'Authorization': `Bearer ${response.data.access_token}`
          }
        }).then(res => {
          if (res.data && res.data.data) {
            const slugs = res.data.data.map(item => item.product.slug);
            localStorage.setItem("wishlist_slugs", JSON.stringify(slugs));
            window.dispatchEvent(new Event("wishlist-slugs-updated"));
          }
        }).catch(err => {
          console.error("Error fetching wishlist on login:", err);
        }).finally(() => {
          navigate("/dashboard");
        });
      } else {
        const msg = Array.isArray(response.data.message) 
          ? response.data.message.join(" ") 
          : response.data.message;
        setError(msg || "Login failed.");
      }
    })
    .catch((error) => {
      setError(error.response?.data?.message || error.message || "An error occurred during login.");
      console.error(error);
    })
    .finally(() => {
      setLoading(false);
    });
  };

  return (
    <>
      <Header mode="dark" />
      <div className="container-fluid">
        <div className="login-wrapper d-flex align-items-center justify-content-center">
          <form className="login-card text-center" onSubmit={handleLogin}>
            <h3 className="login-title">Log In</h3>

            {error && <div className="alert alert-danger">{error}</div>}

            <input
              type="text"
              className="form-control login-input"
              placeholder="Email or Phone Number"
              value={emailOrPhone}
              onChange={(e) => setEmailOrPhone(e.target.value)}
              required
            />

            <input
              type="password"
              className="form-control login-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <div className="d-flex justify-content-between align-items-center login-options">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="rememberMe" />
                <label className="form-check-label" htmlFor="rememberMe">
                  Remember Me
                </label>
              </div>
              <Link to="/forgetpassword" className="forgot-link">
                Forgot Password?
              </Link>
            </div>

            <button type="submit" className="btn login-btn w-100" disabled={loading}>
              {loading ? "Logging in..." : "Log In"}
            </button>

            <p className="register-text">Don't have an account?</p>

            <Link to="/register">
              <p className="register-link">Register Now</p>
            </Link>
          </form>
        </div>
      </div>
      <Feature />
      <Footer />
    </>
  );
}
